export default __webpack_public_path__ + "static/media/C_03_01_bg.1c101d48.mp4";